import { Paper, Portal, Skeleton, styled } from "@mui/material";
import { StyledLinearProgress } from "components/loader/StyledLinearProgress";
import { PaddedPaper } from "components/surfaces/PaddedPaper";

interface Props {
  footerRef: HTMLDivElement;
  mapOverlayContainer: HTMLDivElement;
}

export function MeasuresPageSkeleton(props: Props) {
  const { footerRef, mapOverlayContainer } = props;
  const numSections = new Array(2).fill(1);
  const numItems = new Array(3).fill(1);

  return (
    <StyledPaddedPaper elevation={0}>
      {numSections.map((section, i) => (
        <Paper elevation={0} className="flex-section" key={i}>
          <Skeleton width={"50%"} height={25} className="header" />
          {numItems.map((item, i) => {
            return <Skeleton key={i} width={"100%"} />;
          })}
          <Skeleton width={"30%"} height={25} />
        </Paper>
      ))}
      <Portal container={footerRef}>
        <StyledPaper className="footer" elevation={0}>
          <Skeleton width={100} height={40} />
          <Skeleton width={100} height={40} />
        </StyledPaper>
      </Portal>
      <Portal container={mapOverlayContainer}>
        <StyledLinearProgress />
      </Portal>
    </StyledPaddedPaper>
  );
}

const StyledPaddedPaper = styled(PaddedPaper)`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: ${({ theme }) => theme.spacing(10)};
  .flex-section {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(2)};
  }
  .header {
    margin-bottom: ${({ theme }) => theme.spacing(2)};
  }

  .MuiSkeleton-root {
    transform: unset;
    transform-origin: unset;
  }
`;

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  .MuiSkeleton-root {
    transform: unset;
    transform-origin: unset;
  }
`;
